module.exports = __webpack_public_path__ + "static/media/Покана за свикване на ОСА на Формопласт АД, насрочено за 30.12.2024 г..69ee10b3.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2024/Покана за свикване на ОСА на Формопласт АД, насрочено за 30.12.2024 г..pdf
// module id = 89
// module chunks = 0